// removed by extract-text-webpack-plugin
module.exports = {"tasks":"tasks-8c2af4","tasks__progress":"tasks__progress-eda48d","tasks__progress-bar":"tasks__progress-bar-74be3b","progress-bar-stripes":"progress-bar-stripes-c94148","tasks__sr-only":"tasks__sr-only-444c46"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/progress-bar/style.pcss
// module id = ./src/blocks/progress-bar/style.pcss
// module chunks = 0